import React from 'react';
import { useSelector } from 'react-redux';
import usePortal from 'react-useportal';
import { AcceptOfferPopup } from '../../../../components/Popup';
import { isRightPanelOpen } from '../../../../redux/selector/Sidebar';
import { getPopupByName } from '../../../../redux/selector/Popups';
import { playerFromList, isPlayerDataLoading } from '../../../../redux/selector/Team';
import OfferCard from './OfferCard';
import { POPUPS } from '../../../../service/constants';

export default function TransfersPlayerCard({
  cardType,
  type,
  status = 1,
  className,
  offer,
  selectPlayer,
  setSelectPlayer,
  minPotentialValue,
  maxPotentialValue,
  ratingRange,
  salary,
  listed,
  sidebarPlayer,
  selectionMode = false,
  ...props
}) {
  const { ACCEPT_OFFER_POPUP } = POPUPS;
  const teamData =
    cardType === 'Buy' || cardType === 'Loan In'
      ? offer?.sending_team
      : offer?.receiving_team;
  const rightSidebarOpen = useSelector(isRightPanelOpen);
  const selectedPlayer = useSelector(playerFromList);
  const isLoading = useSelector(isPlayerDataLoading);

  const acceptOfferPopupData = useSelector(getPopupByName(ACCEPT_OFFER_POPUP));
  const isCardDisabled =
    selectedPlayer?._id !== offer?.player?._id && rightSidebarOpen && !isLoading;
  const { Portal } = usePortal({
    bindTo: document && document.querySelector('#modal'),
  });

  if (!offer?.player || !teamData) return null;

  const hasLowerOffer = parseInt(offer.transfer_fee_offer) < minPotentialValue;
  const hasHigherOffer = parseInt(offer.transfer_fee_offer) > maxPotentialValue;

  const noOfferLimit = !hasLowerOffer && !hasHigherOffer;
  return (
    <>
      {acceptOfferPopupData && acceptOfferPopupData.id === offer._id && (
        <Portal>
          <AcceptOfferPopup
            popupName={ACCEPT_OFFER_POPUP}
            loanEndDate={offer.loan_end_date}
            hasLowerOffer={hasLowerOffer}
            hasHigherOffer={hasHigherOffer}
            noOfferLimit={noOfferLimit}
          />
        </Portal>
      )}
      <OfferCard
        offer={offer}
        cardType={cardType}
        isDisabled={!selectionMode && isCardDisabled}
        selectionMode={selectionMode}
        type={type}
        status={offer.status}
        className={className}
        name={teamData.name}
        player={offer.player}
        _id={offer._id}
        selectPlayer={selectPlayer}
        setSelectPlayer={setSelectPlayer}
        transfer_fee_offer={offer.transfer_fee_offer}
        createdAt={offer.createdAt}
        loan_end_date={offer.loan_end_date}
        listed={listed}
        sidebarPlayer={sidebarPlayer}
        {...props}
      />
    </>
  );
}
